import { MouseEvent } from 'react';

import {
  DotItemDotProps as RechartsDotItemDotProps,
  Dot as RechartsDot,
} from 'recharts';

type Props = Omit<RechartsDotItemDotProps, 'points'> & {
  onClick?: (props: RechartsDotItemDotProps, event: MouseEvent) => void;
  testId: string;
};

export const Dot = (props: Props) => {
  return (
    <RechartsDot
      {...props}
      data-testid={props.testId}
      cursor={props.onClick ? 'pointer' : undefined}
    />
  );
};
